// src/contexts/ToastContext.js
import React, { createContext, useContext } from 'react';

const ToastContext = createContext(null);

// Make sure you have a ToastProvider
export const ToastProvider = ({ children }) => {
  // Simple toast implementation - you can replace with react-toastify
  const showToast = (message, type = 'info') => {
    console.log(`[${type.toUpperCase()}] ${message}`);
    // If you have a toast library, use it here
  };

  const toast = {
    info: (msg) => showToast(msg, 'info'),
    success: (msg) => showToast(msg, 'success'),
    error: (msg) => showToast(msg, 'error'),
    warning: (msg) => showToast(msg, 'warning'),
  };

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    console.warn('useToast used outside of ToastProvider - returning fallback');
    // Return fallback instead of throwing error
    return {
      toast: {
        info: (msg) => console.log('[INFO]', msg),
        success: (msg) => console.log('[SUCCESS]', msg),
        error: (msg) => console.error('[ERROR]', msg),
        warning: (msg) => console.warn('[WARNING]', msg),
      }
    };
  }
  return context;
};

export default ToastContext;